import { useDispatch, useSelector } from 'react-redux'
import { useCallback } from 'react'
import { Dialog, Toast } from 'types'
import { 
    showDialogAction, 
    hideDialogAction, 
    showSidebarAction, 
    hideSidebarAction, 
    addToastAction,
    removeFirstToastAction,
    showGalleryFullscreenAction,
    hideGalleryFullscreenAction,
    setSearchDisplayDeletedAction,
} from '../features/layout/layoutSlice'
import { RootState } from 'state/store'

const useLayout = () => {
    const dispatch = useDispatch()

    const showDialogState = useSelector((state: RootState) => state.layout.showDialog)
    const sidebarIsVisible = useSelector((state: RootState) => state.layout.sidebarIsVisible)
    const dialogQueue = useSelector((state: RootState) => state.layout.dialogQueue)
    const dialogData = useSelector((state: RootState) => state.layout.dialogData)
    const toasts = useSelector((state: RootState) => state.layout.toasts)
    const galleryFullscreen = useSelector((state: RootState) => state.layout.galleryFullscreen)
    const searchDisplayDeleted = useSelector((state: RootState) => state.layout.searchDisplayDeleted)

    // Functions with same names as reducers (without "Action" suffix)
    const showDialog = useCallback((dialog_id: string, data?: Dialog) => dispatch(showDialogAction({dialog_id, data})), [dispatch])
    const hideDialog = useCallback(() => dispatch(hideDialogAction()), [dispatch])
    const showSidebar = useCallback(() => dispatch(showSidebarAction()), [dispatch])
    const hideSidebar = useCallback(() => dispatch(hideSidebarAction()), [dispatch])
    const showGalleryFullscreen = useCallback(() => dispatch(showGalleryFullscreenAction()), [dispatch])
    const hideGalleryFullscreen = useCallback(() => dispatch(hideGalleryFullscreenAction()), [dispatch])
    const setSearchDisplayDeleted = useCallback((value: boolean) => dispatch(setSearchDisplayDeletedAction(value)), [dispatch])

    const addToast = (toast: Toast) => {
        dispatch(addToastAction({ text: toast.text, colorScheme: toast.colorScheme }))
        setTimeout(() => {
            dispatch(removeFirstToastAction())
        }, 5000)
    }

    // Alias functions for better UX (keeping backward compatibility)
    const openDialog = showDialog
    const closeDialog = hideDialog
    const openSidebar = showSidebar
    const closeSidebar = hideSidebar

    return {
        // State
        showDialogState,
        sidebarIsVisible,
        dialogQueue,
        dialogData,
        toasts,
        galleryFullscreen,
        searchDisplayDeleted,

        // Functions with same names as reducers
        showDialog,
        hideDialog,
        showSidebar,
        hideSidebar,
        addToast,

        // Alias functions (backward compatibility)
        openDialog,
        closeDialog,
        openSidebar,
        closeSidebar,
        showGalleryFullscreen,
        hideGalleryFullscreen,
        setSearchDisplayDeleted,
    }
}

export default useLayout